import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import moment from 'moment';
import { Message, PanelRow, Tooltip } from '@getro/rombo';

import getOcpStatus from '../../../helpers/getOcpStatus';

const JobSource = ({ source, index }) => {
  const { activeJobsCount, scrapedAt, scraperStatus, publicUrl, url, updateFrequency } = source;
  const ocpStatus = getOcpStatus(scraperStatus);

  return (
    <Flex
      width={1}
      flexDirection="column"
      mt={index === 0 ? '0px' : '16px'}
      pt="16px"
      sx={{ borderTop: index === 0 ? 'none' : '1px solid', borderColor: 'border.subtle', fontSize: '14px' }}
    >
      <PanelRow title="URL" mb="8px">
        <Text sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '100%' }}>
          {publicUrl || url}
        </Text>
      </PanelRow>
      <PanelRow title="Update frequency" mb="8px">
        <Text>
          {scraperStatus === 'manual' ? 'Monthly' : `${updateFrequency || 0} ${updateFrequency > 1 ? 'days' : 'day'}`}
        </Text>
      </PanelRow>
      {ocpStatus.explanationText && (
        <PanelRow mt={[3, 3, 0]} mb="8px">
          <Message type="info">
            <span dangerouslySetInnerHTML={{ __html: ocpStatus.explanationText }} />
          </Message>
        </PanelRow>
      )}
      <PanelRow title="Last updated" mb="8px">
        {scrapedAt ? (
          <Tooltip
            content={scrapedAt ? moment(scrapedAt).format('D MMM, YYYY [at] hh:mm a') : 'Not available'}
            trigger={<span>{moment().from(scrapedAt, true)} ago</span>}
          />
        ) : (
          'Never'
        )}
      </PanelRow>
      <PanelRow title="Open jobs">
        <Text>{activeJobsCount || 0}</Text>
      </PanelRow>
    </Flex>
  );
};

JobSource.propTypes = {
  source: PropTypes.shape({
    activeJobsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scrapedAt: PropTypes.string,
    scraperStatus: PropTypes.string,
    url: PropTypes.string,
    publicUrl: PropTypes.string,
    updateFrequency: PropTypes.number,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default JobSource;
